// extracted by mini-css-extract-plugin
module.exports = {"faqSectionContainer":"Faq_faqSectionContainer__D9X8P","faqSectionHeader":"Faq_faqSectionHeader__zVTMg","faqAccordionControls":"Faq_faqAccordionControls__JDSua"};